import { useTheme } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { UIFlightData } from "@flights/types";
import useProfiler from "../../../../../../../hooks/useProfiler";
import useFormatPrice from "../../../../../../../hooks/useFormatPrice";
import { isOfMetaOrigin } from "../../../../../../../utils/marketing-url-params";
import web_flights_fd_genius_saving_badge from "../../../../../../../utils/experiments/genius/web_flights_fd_genius_saving_badge";

const useGeniusRewardsInfoController = (flight: UIFlightData) => {
  const theme = useTheme();
  const i18n = useI18n();
  const { isLoggedIn } = useProfiler();
  const { formatPrice } = useFormatPrice();

  const hasFlightGeniusDiscount = flight.priceBreakdown?.bcomPricingItems?.some(
    (item) => item.itemType === "GENIUS_DEAL" || item.itemType === "GENIUS_AIRLINE_FARE"
  );
  // On FlightDetails we only get one checked baggage option (the cheapest one).
  const hasCheckedBaggageDiscount =
    (flight.ancillaries?.checkedInBaggage?.options.length ?? 0) > 0 &&
    flight.ancillaries?.checkedInBaggage?.options[0].priceBreakdown?.bcomPricingItems?.some(
      (item) => item.itemType === "GENIUS_CHECKED_BAG"
    );
  const hasFlexTicketDiscount = flight.ancillaries?.flexibleTicket?.priceBreakdown?.bcomPricingItems?.some(
    (item) => item.itemType === "GENIUS_FLEXTICKET"
  );
  const hasGeniusRewards = hasFlightGeniusDiscount || hasCheckedBaggageDiscount || hasFlexTicketDiscount;

  // Using same logic as in useExtraProductsInfo.tsx.
  const showLoadingPrice = isOfMetaOrigin();

  /* start - web_flights_fd_genius_saving_badge */
  if (isLoggedIn() && hasFlightGeniusDiscount) web_flights_fd_genius_saving_badge.useTrackStages();
  const isInGeniusSavingBadgeExperiment = isLoggedIn() && web_flights_fd_genius_saving_badge.trackWithDefaultStage();

  const formattedSavingsAmount = flight.priceBreakdown?.totalGeniusFareDiscount
    ? formatPrice(flight.priceBreakdown.totalGeniusFareDiscount, { isDiscount: true })
    : undefined;
  /* end - web_flights_fd_genius_saving_badge */

  return {
    hasGeniusRewards,
    headerColor: theme.colors.color_brand_primary_background,
    subheader: i18n.trans(t("flights_fd_genius_rewards_subtitle")),
    checkedBaggageDiscount: hasCheckedBaggageDiscount && flight.ancillaries?.checkedInBaggage?.options[0],
    showCheckedBaggageLoadingPrice: showLoadingPrice,
    flexTicketDiscount: hasFlexTicketDiscount && flight.ancillaries?.flexibleTicket,
    flightGeniusDiscount: hasFlightGeniusDiscount && i18n.trans(t("flights_fd_lower_price")),
    isInGeniusSavingBadgeExperiment: isInGeniusSavingBadgeExperiment && formattedSavingsAmount
  };
};

export default useGeniusRewardsInfoController;
